<div *ngIf="showCount" class="chart-statistics">
  <h4>Total Charts Count: {{ totalChartCount }}</h4>
</div>
<div class="p-grid p-fluid">
  <div class="p-col-12 p-md-12 p-lg-12">
    <app-bulk-actions-dropdown class="chart-grid__bulk-action-menu" [actions]="actions"
      [selectedItems]="this.basicGridComponent.selection" [hasData]="true">
    </app-bulk-actions-dropdown>
    <app-basic-grid [configuration]="configuration" [request]="request" [views]="views" [filterOnInit]="loadFilter"
      [data]="chartData" [gridFilterNeeded]="false" [hideFilterItems]="hideFilterItems"
      [filterTemplate]="!disableFilter ? filterForm : null" filterHeaderText="Charts" [refreshViews]="refreshViews"
      (removeFilter)="onRemoveFilter($event)" [isFilterValid]="validateFilterForm()">
    </app-basic-grid>
    <app-custom-pagination (fetchPage)="makeRequest($event)" [config]="configuration"></app-custom-pagination>
    <ng-template #filterForm>
      <app-tab-menu orientation="left">
        <app-tab-panel header="Member Demographics">
          <form [formGroup]="form">
            <div class="required-message">Please enter a Member ID, First (or) Last Name to search</div>
            <div class="p-col-12 p-md-12 p-lg-12 basic-form">
              <form-factory [formGroup]="form" [model]="memberIdInput"></form-factory>
              <form-factory [formGroup]="form" [model]="memberFirstNameInput"></form-factory>
              <form-factory [formGroup]="form" [model]="memberLastNameInput"></form-factory>
              <form-factory [formGroup]="form" [model]="dobInput"></form-factory>
            </div>
          </form>
        </app-tab-panel>
        <app-tab-panel header="Chart ID">
          <form [formGroup]="form">
            <div class="p-col-12 p-md-12 p-lg-12 basic-form">
              <form-factory [formGroup]="form" [model]="chartIdInput"></form-factory>
            </div>
          </form>
        </app-tab-panel>
        <app-tab-panel header="Provider / Group Name">
          <form [formGroup]="form">
            <div class="required-message">Please enter Provider Name to search</div>
            <div class="p-col-12 p-md-12 p-lg-12 basic-form">
              <form-factory [formGroup]="form" [model]="providerNameInput"></form-factory>
              <form-factory [formGroup]="form" [model]="groupNameInput"></form-factory>
            </div>
          </form>
        </app-tab-panel>
        <app-tab-panel header="Date of Service">
          <form [formGroup]="form">
            <div class="p-col-12 p-md-12 p-lg-12 basic-form">
              <form-factory [formGroup]="form" [model]="dateOfServiceFromInput"></form-factory>
              <form-factory [formGroup]="form" [model]="dateOfServiceToInput"></form-factory>
            </div>
          </form>
        </app-tab-panel>
      </app-tab-menu>
    </ng-template>
  </div>
</div>